module.exports = __webpack_public_path__ + "img/img74.e902d123.svg";